import ninegrid from "../index.js";

export class ngFields
{
	#owner;
	#fields;

	constructor(owner) {
		this.#owner = owner;
		this.#init();
	};
	
	get() {
		return this.#fields;
	};
	
	add = (arr) => {
		this.#fields.push(...arr);
		
		this.#adjust();
	};

	indexOf(v) {
		return this.#fields.indexOf(v);
	};
	
	includes(v) {
		return this.#fields.includes(v);
	};
	
	#adjust = () => {
		this.#fields = [...new Set(this.#fields)];
		
		["","__ng"].forEach(v => {
			const idx = this.#fields.indexOf(v);
			if (idx > -1) this.#fields.splice(idx, 1);
		});
		
		this.#fields.sort((a, b) => { return (a.length < b.length) ? 1 : -1; });
	};

	#init = () => {
		
		this.#fields = [];
		
		const layout = this.#owner.shadowRoot.querySelector("ng-foot").shadowRoot.querySelector("ng-layout");
		if (!layout) return;
		
		for (const tbl of layout.tables) {
			
			$("[data-bind]", tbl).each((i, el) => {
				this.#fields.push(el.dataset.bind);
			});
			
			["data-expr","background-color","color","tooltip","visible","readonly","enable-button","enable-check","class-expr","icon-color","icon-src"].forEach(attr => {
				
				$(`[${attr}]`, tbl).each((i, el) => {
	
					var expr = el.getAttribute(attr);
					
					if (expr.indexOf("data.") < 0) {
						const lastIndex = expr.search(/[(]/g);

						if (lastIndex > 0) {
							try {
								expr = String(window[expr.substring(0, lastIndex).trim()]);
							} catch (e) {
								expr = "";
							}
						}
					}
	
					expr.split("data.").forEach(v => {

						if (v.trim() != "") {
	
							const lastIndex = v.search(/[^_A-Za-z0-9]/g);
							if (lastIndex >= 0) {
								this.#fields.push(v.substring(0, lastIndex));
							}
							else {
								/**
								 * data-expr="data.xxx" 처럼 단순한 경우
								 */
								if (expr.startsWith("data.")) {
									this.#fields.push(v.replace("data.", ""));
								}
							}
						}
					});
				});
			});
		}
		
		this.#adjust();
	};
};